// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b769942","455":"27d7150b","977":"dd18d331"}[chunkId] + ".chunk.js";
};